<ng-template *ngIf="template" [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{type: type, id: id, params: params}">
</ng-template>

<div *ngIf="!template">
    Lädt&hellip;
</div>
